import { NextPage } from 'next'

import SignUpForm from 'components/auth/sign-up'
import { MetaTags } from '~shared'
import { Layout } from '~ui'

const RewardsJoinPage: NextPage = () => (
  <Layout>
    <MetaTags title="Join" />
    <Layout.Header />
    <Layout.Main withPadding withSidebar={false} backgroundColor="g-black">
      <SignUpForm isReferralMode />
    </Layout.Main>
  </Layout>
)

export default RewardsJoinPage
